import { useContext, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThLarge, faThList } from '@fortawesome/free-solid-svg-icons'
import classnames from 'classnames'
import ListSort from './../../../components/ui/ListSort'
import { t } from '../../../utils/index'
import styles from './../_songsPage.module.scss'
import Switcher from '../../../components/ui/SwitcherComponent'
import { useAuth } from '../../../utils/auth'
import { SearchContext } from '..'

interface SongsListHeaderProps {
  toggleAside: () => void
  asideShown: boolean
  toggleView: (string) => void
  view: string
}

const SongsListHeader: React.FC<SongsListHeaderProps> = ({
  toggleAside,
  asideShown,
  toggleView,
  view
}: SongsListHeaderProps) => {
  const { filtersState, updateQueryParams } = useContext(SearchContext)
  const [isChecked, setIsChecked] = useState(filtersState.favorite)
  const { isAuthenticated } = useAuth()
  return (
    <div className={styles.songsPageHeader}>
      <div className={styles.songsPageHeaderButtons}>
        <button
          className={classnames('button', { 'is-black': !asideShown })}
          onClick={() => toggleAside()}
        >
          {t('Filter')}
        </button>
        <ListSort SearchContext={SearchContext} onUpdate={updateQueryParams} />
      </div>

      <div className={styles.songsPageHeaderActions}>
        <div className={styles.songsPageHeaderActionsTitle}>{t('Songs')}</div>
        <div className={styles.songsPageHeaderActionsMain}>
          {isAuthenticated && (
            <Switcher
              isChecked={isChecked}
              onClick={() => {
                setIsChecked(!isChecked)
                updateQueryParams({
                  ...filtersState,
                  favorite: !isChecked
                })
              }}
              label={t('Favorites')}
            />
          )}
          <div className={classnames(styles.uiTabs, styles.actionItem)}>
            <button
              className={classnames(styles.tabLink, {
                [styles.tabLinkActive]: view == 'list'
              })}
              onClick={() => toggleView('list')}
            >
              <FontAwesomeIcon icon={faThList} size="2x" />
            </button>

            <button
              className={classnames(styles.tabLink, {
                [styles.tabLinkActive]: view == 'table'
              })}
              onClick={() => toggleView('table')}
            >
              <FontAwesomeIcon icon={faThLarge} size="2x" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SongsListHeader
